import { render, staticRenderFns } from "./otelislem.vue?vue&type=template&id=5f2ff14c&scoped=true"
import script from "./otelislem.vue?vue&type=script&lang=js"
export * from "./otelislem.vue?vue&type=script&lang=js"
import style0 from "./otelislem.vue?vue&type=style&index=0&id=5f2ff14c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2ff14c",
  null
  
)

export default component.exports